import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import SurveyResponse from '@/models/SurveyResponse.js'

export const useSurveyResponseStore = defineStore('surveyResponseStore', () => {
  let syncableModel = useSyncableModel(useApiResource('survey_responses'), {
    className: SurveyResponse.modelName.name,
    paramKey: SurveyResponse.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
